import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import CommissionPointsAndPrice from '../../../../../CommissionPointsAndPrice';

import s from './PriceBlock.scss';

export interface Props {
  priceTextClassName?: string;
  price?: number;
  dollarsCost?: string;
  priceLabel?: string;
  priceLabelOnTop?: boolean;
}

const PriceBlock: React.FC<Props> = ({
  priceTextClassName,
  price,
  priceLabel,
  priceLabelOnTop,
  dollarsCost,
}) => {
  const { t } = useTranslation();
  return dollarsCost !== undefined ? (
    <div className={s['price-wrapper']}>
      <CommissionPointsAndPrice
        points={price}
        price={dollarsCost}
        dollarsClassName={s['price-dollars']}
        pointsClassName={s['price-points']}
      />
    </div>
  ) : (
    <Flex
      justifyContent={priceLabelOnTop ? 'flex-end' : 'center'}
      direction={priceLabelOnTop ? 'column-reverse' : 'column'}
      className={classnames(s['price'], priceLabelOnTop && s['price-on-top'])}
    >
      <div className={classnames(s['price-value'], priceTextClassName)}>
        {price}
      </div>
      <div className={classnames(s['price-label'], priceTextClassName)}>
        {t(priceLabel!)}
      </div>
    </Flex>
  );
};
PriceBlock.displayName = 'PriceBlock';

export default PriceBlock;
